import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSupportComponent } from '@fi-shared/fi-support/fi-support.component';
import { MatButtonModule } from '@angular/material/button';
import { FiContactSupportDialogComponent } from './fi-contact-support-dialog/fi-contact-support-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiContactSupportMainSectionComponent } from './fi-contact-support-dialog/fi-contact-support-main-section/fi-contact-support-main-section.component';
import { FiContactSupportContactMethodSectionComponent } from './fi-contact-support-dialog/fi-contact-support-contact-method-section/fi-contact-support-contact-method-section.component';
import { FiContactSupportEmailSectionComponent } from './fi-contact-support-dialog/fi-contact-support-email-section/fi-contact-support-email-section.component';
import { FiContactSupportFeedbackSectionComponent } from './fi-contact-support-dialog/fi-contact-support-feedback-section/fi-contact-support-feedback-section.component';
import { FiContactSupportSectionHeaderComponent } from './fi-contact-support-dialog/fi-contact-support-section-header/fi-contact-support-section-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { FiSelectedFilesListModule } from '@fi-shared/selected-files-list/selected-files-list.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';
import { FeedbackDialogComponent } from '@fi-shared/fi-support/feedback-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { FiSectionCardModule } from '@fi-shared/fi-section-card/fi-section-card.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        FiInsertMediaModule,
        FiDirectivesModule,
        FiSelectedFilesListModule,
        MatCheckboxModule,
        FiErrorMessageModule,
        FiAutofocusModule,
        FiSelectedFilesListModule,
        FiDirectivesModule,
        FiPrintDownloadModule,
        FiSectionCardModule,
    ],
    declarations: [
        FiSupportComponent,
        FiContactSupportDialogComponent,
        FiContactSupportMainSectionComponent,
        FiContactSupportContactMethodSectionComponent,
        FiContactSupportEmailSectionComponent,
        FiContactSupportFeedbackSectionComponent,
        FiContactSupportSectionHeaderComponent,
        FeedbackDialogComponent,
    ],
    providers: [FiSupportService],
    exports: [FiSupportComponent],
})
export class FiSupportModule {}
